import type { SmsSummary as SmsSummaryData } from '@mathflat/domain/Sms'

import { DTO } from '../DTO'

export class SmsSummary extends DTO {
  success: number
  fail: number
  requested: number

  constructor(data: SmsSummaryData) {
    super()
    this.success = data.success
    this.fail = data.fail
    this.requested = data.requested
  }
}
